import React from "react";
import { Six  } from "./Chart.config";
import ShreeDayTable from "./ShreeDayTable";

const ShreeDay = ({ chartData }) => {
   return <ShreeDayTable staticData={Six} chartData={chartData} />;
};

export default ShreeDay;
